var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"toast-container"},[_c('div',{class:['toast', _vm.type]},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }